const awsmobile = {
    aws_project_region: 'eu-west-2',
    aws_cognito_identity_pool_id: 'eu-west-2:60c26583-1cb9-4bf4-a3b5-fd02fb76c7e2',
    aws_cognito_region: 'eu-west-2',
    aws_user_pools_id: 'eu-west-2_k7saNa0lT',
    aws_user_pools_web_client_id: '3e3tje2cdud4ntqnl8l640qd52',
    oauth: {},
};

export default awsmobile;